import axios from './axiosInstance';
import { APIParkLog } from '../../types';

interface SportAreaParams {
  sport: string;
  areaId: string;
}

interface GetMatrixParams extends SportAreaParams {
  day: number;
}

interface GetCsvParams extends SportAreaParams {
  day: number;
  fileName: string;
}

interface GetPdfParams extends SportAreaParams {
  day: number;
  fileName: string;
}

interface GetExportParams extends SportAreaParams {
  startDate: string;
  endDate: string;
  fileName: string;
}

interface GetExportPdfParams extends SportAreaParams {
  startDate: string;
  endDate: string;
}

interface GetLogsParams extends SportAreaParams {
  featureId?: string;
  trailId?: string;
  day?: number;
}

const getMatrix = ({ sport, areaId, day }: GetMatrixParams): Promise<any> => {
  let url = `/${sport}/areas/${areaId}/logs/matrix?day=${day}`;
  return axios.get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

const getMatrixIngredients = ({ sport, areaId, day }: GetMatrixParams): Promise<any> => {
  let url = `/${sport}/areas/${areaId}/logs/matrixingredients?day=${day}`;
  return axios.get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log(error);
    });
};

const getCsv = ({ sport, areaId, day, fileName }: GetCsvParams): Promise<void> => {
  let url = `/${sport}/areas/${areaId}/logs/csv?day=${day}`;
  return axios.get(url)
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.csv`); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch((error) => {
      console.log(error);
    });
};

const getPdf = ({ sport, areaId, day, fileName }: GetPdfParams): Promise<void> => {
  let url = `/${sport}/areas/${areaId}/logs/pdf?day=${day}`;
  return axios.get(url, {
    responseType: 'blob',
    headers: {
      'Accept': 'application/pdf'
    }
  })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.pdf`); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch((error) => {
      console.log(error);
    });
};

const getExport = ({ sport, areaId, startDate, endDate, fileName }: GetExportParams): Promise<void> => {
  let url = `/${sport}/areas/${areaId}/logs/export?startDate=${startDate}&endDate=${endDate}`;
  return axios.get(url, {
    responseType: 'arraybuffer',
    headers: {
      'Accept': 'application/zip'
    }
  })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${fileName}.zip`); //or any other extension
      document.body.appendChild(link);
      link.click();
    })
    .catch((error) => {
      console.log(error);
    });
};

const getLogs = ({ sport, areaId, featureId, trailId, day }: GetLogsParams): Promise<APIParkLog[] | void> => {
  let url = `/${sport}/areas/${areaId}/logs`;
  // add query parameters
  const queryParameters = [`users=true`];
  if (day) {
    queryParameters.push(`day=${day}`);
  }
  if (featureId) {
    queryParameters.push(`feature=${featureId}`);
  }
  if (trailId) {
    queryParameters.push(`trail=${trailId}`);
  }
  if (queryParameters && queryParameters.length) {
    url += `?${queryParameters.join('&')}`;
  }
  return axios.get(url)
  .then((response) => {
    return response.data;
  })
  .catch((error) => {
    console.log(error);
  });
}

const getExportPdf = ({ sport, areaId, startDate, endDate }: GetExportPdfParams): Promise<any> => {
  let url = `/${sport}/areas/${areaId}/logs/exportpdf`;
  return axios.get(url, {
    params: { startDate, endDate },
  })
    .then((response) => {
      return response.data;
    });
};

const parkLogFunctions = {
  getMatrix,
  getMatrixIngredients,
  getCsv,
  getPdf,
  getExport,
  getExportPdf,
  getLogs,
};

export default parkLogFunctions;
